import m from 'mithril'

export default {
    view() {
        return m("div.k-portlet",
            [
                m("div.k-portlet__head",
                    m("div.k-portlet__head-label",
                        m("h3.k-portlet__head-title",
                            [
                                "Common Questions"
                            ]
                        )
                    )
                ),
                m("div.k-portlet__body",
                    m("div.k-list.k-list--badge",
                        [
                            m("a[href='#'].k-list__item",
                                [
                                    m("span.k-list__badge.k-list__badge--success"),
                                    m("span.k-list__icon",
                                        m("i.flaticon2-chronometer.k-font-success")
                                    ),
                                    m("span.k-list__text", "How do i log into the app?")
                                ]
                            ),

                            m("a[href='#'].k-list__item",
                                [
                                    m("span.k-list__badge.k-list__badge--success"),
                                    m("span.k-list__icon",
                                        m("i.flaticon2-chronometer.k-font-success")
                                    ),
                                    m("span.k-list__text", "How do i see the data captured by app users?")
                                ]
                            ),

                            m("a[href='#'].k-list__item",
                                [
                                    m("span.k-list__badge.k-list__badge--success"),
                                    m("span.k-list__icon",
                                        m("i.flaticon2-chronometer.k-font-success")
                                    ),
                                    m("span.k-list__text", "How do i export captured data using templates?")
                                ]
                            ),
                        ]
                    )
                )
            ]
        )
    }
}